export default {
    menu: {
        dashboard: 'dashboard',
        auctions: 'auctions',
        auction_calendars: 'calendar',
        selection_sites: 'selection sites',
        subscribers: 'affiliates'
    },
    auction: {
        auctions: 'Auctions',
        open: 'Open',
        published: 'Published',
        closed: 'Closed',
        redistributing: 'Redistributing',
        not_available: 'No Auctions available',
        will_close_at: 'Auction will close at',
        redistribution_will_close_at: 'Auction redistribution will close at',
        closed_at: 'Auction closed at',
        will_open_at: 'Auction will open at',
        opening_date: 'Opening date',
        closing_date: 'Closing date',
        at_time: 'at',
        opening: 'Opening',
        closing: 'Closing',
        you_are_winning: 'You are winning',
        you_can_bid_on: 'You can bid on',
        product_category: 'Product category',
        total_quantity: 'Total quantity',
        min_quantity: 'QMGC',
        redistributable_quantity: 'Redistributable quantity',
        details: 'Details',
        lot: 'Lot',
        lot_count: 'Lot count',
        lot_list: 'Lot List',
        waste_code: 'Waste Code',
        start_price: 'Start Price',
        effective_price: 'Effective Price',
        availability: 'Availability',
        expiration: 'Expiration',
        remaining: 'Time left',
        bid: 'Bid',
        bid_count: 'Bid Count',
        as_group: 'group',
        redistribution: 'Lot redistribution',
        no_preemptions_available: 'You have no lots available for redistribution',
        choose_preemptions: 'Choose the lots you would like to preempt',
        winning: 'Winning'
    },
    calendar: {
        calendar: 'Auction calendar'
    },
    lot: {
        choose_bid: 'Choose raises for lot',
        you_are_bidding: 'You are about to make {0} raises.',
        you_are_preempting: 'Stai per confermare il lotto',
        value: 'Value:',
        first_bid: 'You are about to bid for lot',
        relaunch_with_successful: 'You relaunched with success',
        relaunch_error: 'Relaunch with error',
        added_to_bookmark: 'Lot {lot} added to bookmarks',
        removed_from_bookmark: 'Lot {lot} removed from bookmarks',
        you_won: 'You won the lot',
        closed: 'Closed lot',
        you_are_winning: 'You are winning',
        outbid: 'Someone outbid you',
        remaining_time: 'Remaining time',
        redistributed_with_success: 'You redistributed with success',
        preempt: 'Preeempt',
        preempted: 'Confirmed',
        premption_not_available: 'N/A',
        assigned_quantity: 'Assigned quantity',
        standard: 'Standard',
        redistribute: 'Redistribute',
        attributes: {
            tipoPagamento: {
                name: 'Payment Type',
                values: {
                    "bonifico45ggDF": "Bank Transfer 45 days",
                    "bonifico30ggDF": "Bank Transfer 30 days",
                    "bonifico60ggDF": "Bank Transfer 60 days",
                    "anticipato": "Advance Payment",
                    "fideiussione": "Bank Guarantee",
                    "riba30ggDF": "Bank Receipt 30 days",
                    "riba45ggDF": "Bank Receipt 45 days",
                    "riba60ggDF": "Bank Receipt 60 days",
                    "rimessaDiretta": "Direct Payment upon Goods Collection"
                }
            },
            territorioInteresse: {
                name: 'Area of Interest',
                values: {
                    "italia": "All of Italy",
                    "nord": "North",
                    "nordovest": "Northwest",
                    "nordest": "Northeast",
                    "centro": "Center",
                    "centronord": "North-Center",
                    "centrosud": "South-Center",
                    "sud": "South",
                    "sudovest": "Southwest",
                    "sudest": "Southeast",
                    "sicilia": "Sicily",
                    "sardegna": "Sardinia"
                }
            },
            provenienzaProdotto: {
                name: 'Product Origin',
                values: {
                    "selezioneRaccoltaDifferenziata": "Selection from Separate Collection"
                }
            },
            dataDisponibilitaMateriale: {
                name: 'Material Availability Date'
            },
            tipologiaProdotto: {
                name: 'Product Type',
                values: {
                    "postconsumo": "Post-Consumer",
                    "industriale": "Industrial"
                }
            },
            statoFisico: {
                name: 'Product Condition',
                values: {
                    "opachiColorati": "Opaque Colored",
                    "coloriMisti": "Mixed Colors",
                    "trasparentiAzzurrati": "Transparent Bluish",
                    "trasparentiIncolore": "Transparent Colorless"
                }
            },
            imballaggio: {
                name: 'Packaging',
                values: {
                    "a10": "Up to 10 tons",
                    "da10a12": "From 10 tons to 12 tons",
                    "da12a14": "From 12 tons to 14 tons",
                    "da14a16": "From 14 tons to 16 tons",
                    "da16a18": "From 16 tons to 18 tons",
                    "da18a20": "From 18 tons to 20 tons",
                    "da22a24": "From 22 tons to 24 tons",
                    "da24a26": "From 24 tons to 26 tons",
                    "da26": "Over 26 tons"
                }
            },
            qualitaMateriale: {
                name: 'Material Quality',
                values: {
                    "conforme": "Compliant with Specification",
                    "nonconforme": "Non-Compliant with Specification",
                    "ottima": "Excellent",
                    "buona": "Good",
                    "sufficiente": "Sufficient",
                    "scarsa": "Poor",
                    "pessima": "Very Poor"
                }
            }
        }
    },
    product: {
        product: 'Product',
    },
    selection_site: {
        selection_sites: 'Selection Sites',
        selection_site: 'Selection Site',
        address: 'Address',
        phone: 'Phone',
        fax: 'FAX'
    },
    subscriber: {
        subscribers: 'Affiliates'
    },
    profile: {
        profile: 'Profile',
        change_password: 'Change Password',
        logout: 'Logout'
    },
    home: {
        welcome: 'Welcome to Aste Corepla',
        login: 'Login'
    },
    notifications: {
        auction_closed: 'Auction closed!',
        new_auction_available: 'New auction available',
        lot_outbid: 'Someone outbid you',
        auction_redistributing_1: 'Asta in redistribuzione - fase 1',
        auction_redistributing_2: 'Asta in redistribuzione - fase 2'
    },
    common: {
        compact_view: 'Compact view',
        full_view: 'Extended view',
        filters_all_lots: 'All the lots',
        filters_only_bookmarked_lots: 'Bookmarked',
        quantity: 'Quantity',
        hide: 'Hide',
        close: 'Close',
        relaunch: 'Relaunch',
        relaunch_same_group: '(sm group)',
        offer: 'Offer',
        hours: 'hours',
        minutes: 'minutes',
        seconds: 'seconds',
        days: 'days',
        company: 'Company',
        group: 'Group',
        price: 'Price',
        date: 'Date',
        refresh: 'Refresh'
    },
    errors: {
        occurred: 'An error occurred',
        closeModal: 'Close',
        forceRefresh: 'Refresh the page',
        logout: 'Log out'
    },
    version: {
        new_available: 'New version available',
        message: 'A new version of the application is available. Update now?',
        update: 'Update'
    }
}